import {
  RiEdit2Fill,
  RiSendPlaneLine,
  RiEyeLine,
  RiFlightTakeoffLine,
  RiCheckboxCircleFill,
  RiHourglass2Line,
  RiCloseCircleLine,
  RiPenNibLine,
} from '@remixicon/react';

export const quoteStatusConfig = {
  'DRAFT': { label: 'Draft', className: 'bg-gray-100 text-gray-600', icon: RiEdit2Fill },
  'SENT': { label: 'Sent', className: 'bg-blue-50 text-blue-600', icon: RiSendPlaneLine },
  'VIEWED': { label: 'Seen', className: 'bg-blue-50 text-blue-600',  icon: RiEyeLine },
  'SIGNED': { label: 'Signed', className: 'bg-blue-50 text-blue-600', icon: RiPenNibLine },
  'IN_TRANSIT': { label: 'In Transit', className: 'bg-amber-50 text-amber-600', icon: RiFlightTakeoffLine },
  'ACCEPTED': { label: 'Paid', className: 'bg-green-150 text-green-450', icon: RiCheckboxCircleFill },
  'PASSENGERS_PENDING': { label: 'Pending Passengers', className: 'bg-amberlight text-amberdark', icon: RiHourglass2Line },
  'REJECTED': { label: 'Rejected', className: 'bg-red-50 text-red-600', icon: RiCloseCircleLine },
};

export const getQuoteStatusConfig = (status) =>
  quoteStatusConfig[status] || { label: status || 'Draft', className: 'bg-gray-100 text-gray-600', icon: RiEdit2Fill };
